// URL helper fonksiyonları
export const createSeoFriendlySlug = (text: string): string => {
  // Türkçe karakterleri İngilizce karşılıklarına çevir
  const turkishToEnglish: Record<string, string> = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G', 
    'ı': 'i', 'I': 'I',
    'İ': 'I', 'i': 'i',
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U'
  };
  
  // Türkçe karakterleri değiştir
  let convertedText = text;
  Object.keys(turkishToEnglish).forEach(turkishChar => {
    const regex = new RegExp(turkishChar, 'g');
    convertedText = convertedText.replace(regex, turkishToEnglish[turkishChar]);
  });
  
  return text
    .toLowerCase()
    .replace(/[çÇğĞıIİiöÖşŞüÜ]/g, (match) => turkishToEnglish[match] || match) // Türkçe karakterleri çevir
    .replace(/[^\w\s-]/g, '') // Diğer özel karakterleri kaldır
    .replace(/[\s_-]+/g, '-') // Boşluk ve alt çizgileri tire ile değiştir
    .replace(/^-+|-+$/g, '') // Başta ve sonda tire varsa kaldır
    .trim();
};

export const createCategorySlug = (categoryName: string): string => {
  return createSeoFriendlySlug(categoryName);
};

export const createForumSlug = (forumId: string, forumName?: string): string => {
  // Forum ID zaten SEO dostu ise direkt kullan
  if (forumId && !forumId.includes(' ') && !forumId.includes('%')) {
    return forumId;
  }
  
  // Forum adından slug oluştur
  if (forumName) {
    return createSeoFriendlySlug(forumName);
  }
  
  return createSeoFriendlySlug(forumId);
};

export const createSoftwareSlug = (softwareName: string): string => {
  return createSeoFriendlySlug(softwareName);
};

// Slug'dan orijinal kategori adını bul
export const findCategoryBySlug = (slug: string, categories: Array<{name: string}>): string | null => {
  // Önce tam eşleşme ara
  const exactMatch = categories.find(cat => createCategorySlug(cat.name) === slug);
  if (exactMatch) return exactMatch.name;
  
  // Benzer eşleşme ara
  const similarMatch = categories.find(cat => 
    createCategorySlug(cat.name).includes(slug) || 
    slug.includes(createCategorySlug(cat.name))
  );
  
  return similarMatch ? similarMatch.name : null;
};

// Slug'dan orijinal yazılım adını bul
export const findSoftwareBySlug = (slug: string, softwareList: string[]): string | null => {
  const match = softwareList.find(software => createSoftwareSlug(software) === slug);
  return match || null;
};